export const listPath = [
    {
        name: 'Главная',
        path: '/',
    },
    {
        name: 'Кейсы',
        path: '/cases',
    },
    {
        name: 'Маркетинг',
        path: '/cases/marketing',
    },
];

export const listTitle = [
    {
        title: 'Миссия невыполнима: 8&nbsp;месяцев, 12&nbsp;продуктов, 100%&nbsp;KPI',
        description: [
            {
                name: 'Клиент',
                details: 'Технопарк «Сколково»',
            },
            {
                name: 'Отрасль',
                details: 'Технологии',
            },
            {
                name: 'Услуги',
                details: 'Performance',
            },
        ],
    },
];
